import React, { Component, Fragment } from 'react';
import DEFINE, {HOTEL as ENUM_HOTEL, PATHS, FEATURE_FLAGS, CACHE_HOTEL_SEARCH_TYPE} from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import Hotel from './../../../../models/Hotel';
import { Button, Icon, Rate, Modal } from 'antd';
import HotelList from './HotelList';
import moment from 'moment'
import Ripple from '../../common/component/Ripple';
import AntSelect, { AntOption } from 'containers/backend/common/component/AntSelect';
import Wrapper from 'containers/backend/common/component/Wrapper';

const { confirm } = Modal;

let permisionActions = [];
let permissionRate = [];
export default class Hotels extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.hotelState.pageSize,
                pageIndex: this.props.hotelState.pageIndex,
            },
            visibleClearCache: false,
            typeClearCache: 1,
        };
    }
    
    showModalClearCache = () => {
        this.setState({
            visibleClearCache: true,
        });
    };

    handleClearCacheOk = () => {
        this.props.clearCache(this.state.typeClearCache);
        this.setState({
            visibleClearCache: false,
        });
    };

    handleClearCacheCancel = () => {
        this.setState({
            visibleClearCache: false,
        });
    };

    onChangeType = (value) => {
        this.setState({
            typeClearCache: value
        })
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.HOTEL);
        permissionRate = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        this.props.getListHotels(this.state.filters);
    }

    showConfirmSync = () => {
        const { t } = this.props;
        confirm({
            title: t('item.rate.titleSyncAll'),
            content: t('item.rate.messageSyncAll'),
            onOk: () => {
                this.props.syncRatesAllHotel()
            },
            onCancel() {},
            okText: t(`action.sync`),
            cancelText: t(`action.cancel`)
          });
    }

    render() {
        const { t } = this.props;
        const { isFetching, isFetchClearCache, totalCount, totalPage, pageIndex, pageSize, hotels } = this.props.hotelState;
        const { isFetchSync, isFetchSyncAll } = this.props.rateState
        const { visibleClearCache, typeClearCache } = this.state;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};

        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'hotels'}
                        titleHeader={t('navigation.hotels')}
                        componentRight={
                            <Fragment>
                                <Wrapper style={{ display: 'flex' }}>
                                    <Wrapper>
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Button
                                                icon="delete"
                                                loading={isFetchClearCache}
                                                onClick={this.showModalClearCache}
                                                className='btn btn-primary mr-3'
                                            >
                                                {t(`action.clearCache`)}
                                            </Button>
                                        </Ripple>
                                        <Modal
                                            title={t('item.rate.clearCache')}
                                            visible={visibleClearCache}
                                            onOk={this.handleClearCacheOk}
                                            onCancel={this.handleClearCacheCancel}
                                            okText={t(`action.clearCache`)}
                                            cancelText={t(`action.cancel`)}
                                        >
                                            <AntSelect className="select-lengthOfTour"
                                                showArrow showSearch
                                                value={typeClearCache}
                                                onChange={(value) => this.onChangeType(value)}
                                                style={{ width: '100%' }}
                                                filterOption={this.selectFilterSearch}
                                            >
                                                {CACHE_HOTEL_SEARCH_TYPE.map((type) => (
                                                    <AntOption key={type.value} value={type.value}>
                                                        {type.lable}
                                                    </AntOption>
                                                ))}
                                            </AntSelect>
                                        </Modal>
                                    </Wrapper>
                                    {/* {
                                        permissionRate && permissionRate.allowSync &&
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Button
                                                icon="sync"
                                                loading={isFetchSyncAll}
                                                onClick={this.showConfirmSync}
                                                className='btn btn-primary'
                                            >
                                                {t(`action.sync`)}
                                            </Button>
                                        </Ripple>
                                    } */}
                                </Wrapper>
                            </Fragment>
                        }
                    />
                    <HotelList loading={isFetching}
                        permisions={permisionActions}
                        permissionRate={permissionRate}
                        hotels={hotels}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeleteHotel={this.onDeleteHotel}
                        syncRates={this.props.syncRates}
                        isFetchSync={isFetchSync}
                        />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });

        this.props.getListHotels(newFilters);
    };

    onDeleteHotel = (hotelItem) => {
    }

    onChangeLanguage = (language) => {
        this.props.getListHotels(this.state.filters)
    }


}
